import React from "react";
import { useSelector } from "react-redux";

import { getReportSettingByKey } from "src/app/ReportGenerator/utils/reportFunctions";
import CustomImage from "../../../../../components/CustomImage/CustomImage";
import { useGetMetaField } from "../../../../../methods/useGetMetaField";

import CreatorPlaceholder from "../../../../../../images/creator-placeholder.svg";
import PublicationPlaceholder from "../../../../../../images/publication-placeholder2.svg";

import SocialProfileIcons from "../../../../../components/IconsWithStatus/SocialProfileIcons/SocialProfileIcons";
import { getImageSource } from "../../../../../../utils/methods";

import "./CoverBox.scss";

export function CoverBox(props) {
  const { data, format } = props;

  const { campaigns } = useSelector((state) => state.reportReducer);

  const projectId = getReportSettingByKey("ids")[0];

  const campaign = campaigns?.aggregated || campaigns[projectId];

  const { creators } = campaign ?? {};

  const src = getImageSource(data?.cover, "big");

  const creatorId = useGetMetaField("creator", data?.metadata)?.value;

  const creator = creators?.find((item) => item.taskId === creatorId);

  return (
    <div
      className="cover-box"
      style={{ top: `-${format.rowHeight / 2 - 3}px` }}
    >
      <div className="cover-box__wrapper">
        {src && (
          <CustomImage
            className="cover-box__wrapper-image"
            src={src}
            fallbackImageSrc={PublicationPlaceholder}
          />
        )}
        {creator && (
          <div className="cover-box__creator">
            <CustomImage
              className="cover-box__creator-avatar"
              src={getImageSource(creator?.cover, "tiny")}
              fallbackImageSrc={CreatorPlaceholder}
            />
            {creator.title}
            <SocialProfileIcons data={creator.socialProfiles} />
          </div>
        )}
      </div>
    </div>
  );
}
